import {put,call} from 'redux-saga/effects';
import MulesoftDataService from '../../services/mulesoftData.services';
import { constants } from '../../constants';

import { setTransacriptSummarySuccess,
         setTransciptSummaryError,
         toggleAlertShowStatus } from '../actions';

export default function * getTransactionSummary(args){
    try {
      const res = yield call([MulesoftDataService, 'getOrderSummary'], args.payload.tReq);
      yield put(setTransacriptSummarySuccess(res));
    } catch (error) {
     yield put(toggleAlertShowStatus({
        showAlert: true,
        alertVarient:'danger',
        alertMessage: constants.APP_MESSAGE.API_RETRIVE_ERROR
        }));    
        yield put(setTransciptSummaryError())
    }
}